module.exports = __webpack_public_path__ + "static/top-9cac3482f5c8e930e0d18fafe4c78cf0.png";